
import React, { useState } from "react";
import Header_Coral from "./Header_Coral";
import Sidebar_Coral from "./Sidebar_Coral";
// import "./LandingCustom.css";
import "./LayoutMain_Coral.module.css";
import "./LayoutMain_Coral_.module.css";
import useWindowDimensions from "../../../hook/useWindowDimensions";


const sidebarClass = {
    intial: {
        main: "app-container app-theme-white body-tabs-shadow fixed-sidebar fixed-header",
        button: "hamburger close-sidebar-btn hamburger--elastic"
    }
}

const sidebarClassMobile = {
    intial: {
        main: "app-container app-theme-white body-tabs-shadow fixed-sidebar fixed-header closed-sidebar-mobile closed-sidebar",
        button: "hamburger hamburger--elastic mobile-toggle-nav"
    }
}

function LayoutMain_Coral(props) {

    const [mainClass, setMainClass] = useState(sidebarClass);
    const [mainClassMobile, setMainClassMobile] = useState(sidebarClassMobile);
    const { width } = useWindowDimensions();

    let class_name;
    const buttonClicked = () => {
        if (mainClass.intial.main.indexOf("closed-sidebar") === -1) {
            setMainClass((preObj) => { return { intial: { main: preObj.intial.main + " closed-sidebar", button: preObj.intial.button + " is-active" } } })

        } else {
            setMainClass((preObj) => { return sidebarClass })
        }
    }

    const buttonClickedMobile = () => {
        // console.log("buttonClickedMobile");
        if (mainClassMobile.intial.main.indexOf("sidebar-mobile-open") === -1) {
            setMainClassMobile((preObj) => { return { intial: { main: preObj.intial.main + " sidebar-mobile-open", button: preObj.intial.button + " is-active" } } })

        } else {
            setMainClassMobile((preObj) => { return sidebarClassMobile })
        }
    }

    if (width >= 991) {
        class_name = mainClass.intial.main;
    } else {
        class_name = mainClassMobile.intial.main;
    }


    return (
        <>
            <div className={class_name}>
                <Header_Coral clsname={mainClass} width={width} clsMobile={mainClassMobile} buttonClicked={buttonClicked} buttonClickedMobile={buttonClickedMobile}></Header_Coral>
                <div className="app-main">
                    <Sidebar_Coral></Sidebar_Coral>
                    <div className="app-main__outer">
                        <div className="app-main__inner">
                            {props.children}
                            
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LayoutMain_Coral;
